import { Component, OnInit } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-comm-batch-running',
  templateUrl: './comm-batch-running.component.html',
  styleUrls: ['./comm-batch-running.component.scss'],
  imports: [CdsIconModule, CdsLanguageModule],
})
export class CommBatchRunningComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
